import { render, staticRenderFns } from "./EmployeeCitizenshipSelect.vue?vue&type=template&id=6dd4539e&"
import script from "./EmployeeCitizenshipSelect.vue?vue&type=script&lang=js&"
export * from "./EmployeeCitizenshipSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports